import React from 'react';
import Anchor from '../../../../components/link/Anchor';

const OpenDeliveryAgentList = (props) => {
  const { getDeliveryAgentList } = props;

  return (
    <Anchor color="primary" isUnderLine={true} text={'( 택배사 리스트 )'} onClick={() => getDeliveryAgentList()} />
  );
};

export default OpenDeliveryAgentList;
